/*!
 * Copyright (c) 2017-present Ghostery GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
    ", document.createElement, ",
    ", document.getElementById,",
    "%5Bhref%5E%3D%22https%3A%2",
    ", document.oncontextmenu",
    "%22%3A%22denied%22%2C%22",
    "aeld, DOMContentLoaded, ",
    "set-local-storage-item, ",
    "trusted-click-element, ",
    "button%5Btitle%3D%22",
    "_ENSIGHTEN_PRIVACY_",
    "%20!important%3B%20",
    "decodeURIComponent",
    "[target=\"_blank\"]",
    "%22%3Afalse%2C%22",
    "[href^=\"https://",
    "%22%3Atrue%2C%22",
    "[href^=\"http://",
    "[data-testid=\"",
    "%22%3Afalse%7D",
    "%22%5D, , 1000",
    "rmnt, script, ",
    ", , reload, 1",
    "BlockDetected",
    "div[class^=\"",
    ".prototype.",
    "contextmenu",
    "leaderboard",
    "no-fetch-if",
    "otification",
    ":has-text(",
    "background",
    "visibility",
    "analytics",
    "container",
    "Container",
    "div[style",
    "document.",
    "necessary",
    "no-xhr-if",
    "placehold",
    "[href*=\"",
    "%5Bdata-",
    "AAAAAAAA",
    "backdrop",
    "disclaim",
    "https://",
    "ia-label",
    "noopFunc",
    "trusted-",
    ".com/\"]",
    "article",
    "consent",
    "Consent",
    "content",
    "keydown",
    "message",
    "privacy",
    "product",
    "sidebar",
    "sponsor",
    "taboola",
    "wrapper",
    "-child",
    "[class",
    "[data-",
    "[id^=\"",
    "accept",
    "banner",
    "bottom",
    "button",
    "cookie",
    "Cookie",
    "COOKIE",
    "google",
    "iframe",
    "nostif",
    "notice",
    "nowoif",
    "policy",
    "Policy",
    "script",
    "widget",
    ":has(",
    ":not(",
    "Accep",
    "block",
    "Block",
    "click",
    "disab",
    "false",
    "fixed",
    "modal",
    "popup",
    "style",
    "video",
    "width",
    "0px;",
    "2%3A",
    "aeld",
    "aopr",
    "body",
    "foot",
    "gdpr",
    "html",
    "icky",
    "ight",
    "Info",
    "set-",
    "show",
    "tion",
    "true",
    "www.",
    " > ",
    "%3A",
    "%3D",
    "522",
    "52C",
    "53A",
    "age",
    "app",
    "box",
    "com",
    "div",
    "dow",
    "ent",
    "lay",
    "out",
    "rap",
    "top",
    "__",
    ", ",
    "\"]",
    "%2",
    "%3",
    "%5",
    "%7",
    "=\"",
    "00",
    "ac",
    "ad",
    "Ad",
    "al",
    "an",
    "ar",
    "at",
    "ce",
    "de",
    "di",
    "e-",
    "ed",
    "en",
    "er",
    "et",
    "he",
    "id",
    "in",
    "la",
    "le",
    "li",
    "lo",
    "ma",
    "mo",
    "mp",
    "ol",
    "on",
    "op",
    "or",
    "ov",
    "ra",
    "re",
    "ro",
    "s_",
    "s-",
    "se",
    "si",
    "sp",
    "st",
    "t-",
    "te",
    "ti",
    "un",
    " ",
    "_",
    "-",
    ";",
    ":",
    ".",
    "(",
    ")",
    "[",
    "]",
    "*",
    "/",
    "#",
    "^",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "B",
    "c",
    "C",
    "d",
    "D",
    "e",
    "E",
    "f",
    "F",
    "g",
    "G",
    "h",
    "H",
    "i",
    "I",
    "j",
    "J",
    "k",
    "l",
    "L",
    "m",
    "M",
    "n",
    "N",
    "o",
    "O",
    "p",
    "P",
    "q",
    "Q",
    "r",
    "R",
    "s",
    "S",
    "t",
    "T",
    "u",
    "U",
    "v",
    "V",
    "w",
    "W",
    "x",
    "y",
    "Y",
    "z",
    "Z"
];
//# sourceMappingURL=cosmetic-selector.js.map